import src from "IMAGE";
export default { src, width: 262, height: 262, blurWidth: 0, blurHeight: 0};
